module.exports = __webpack_public_path__ + "assets/email-white.3e76264a.svg";